import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import { getImgUrl } from '../../utils';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionL');
    const item1 = {
        jp: 'https://websiteoss.ecoflow.com/upload/image/1745378881934/L1.jpg',
        us: 'https://websiteoss.ecoflow.com/upload/image/1744598089473/1-us.jpg',
        ca: 'https://websiteoss.ecoflow.com/upload/image/1744598090969/1.jpg',
        eu: 'https://websiteoss.ecoflow.com/upload/image/1745724650990/UK1.jpg',
        eu: 'https://websiteoss.ecoflow.com/upload/image/1745724650990/UK1.jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1745724650990/UK1.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1745724528512/DE1.jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1745724560719/FR1.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1745724615173/IT1.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1745724559799/ES1.jpg',
        au: 'https://websiteoss.ecoflow.com/upload/image/1745724650990/UK1.jpg',
    };
    const item2 = {
        jp: 'https://websiteoss.ecoflow.com/upload/image/1745378882501/L2.jpg',
        us: 'https://websiteoss.ecoflow.com/upload/image/1744598091189/2-us.jpg',
        ca: 'https://websiteoss.ecoflow.com/upload/image/1744598275812/2.jpg',
        eu: 'https://websiteoss.ecoflow.com/upload/image/1745724651232/UK2.jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1745724651232/UK2.jpg',
        uk: 'https://websiteoss.ecoflow.com/upload/image/1745724651232/UK2.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1745724528682/DE2.jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1745724560528/FR2.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1745724615700/IT2.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1745724560149/ES2.jpg',
        au: 'https://websiteoss.ecoflow.com/upload/image/1745724651232/UK2.jpg',
    };
    const item3 = {
        jp: 'https://websiteoss.ecoflow.com/upload/image/1745378882947/L3.jpg',
        us: 'https://websiteoss.ecoflow.com/upload/image/1744598089677/3-us.jpg',
        ca: 'https://websiteoss.ecoflow.com/upload/image/1744598090720/3.jpg',
        eu: 'https://websiteoss.ecoflow.com/upload/image/1745724651871/UK3.jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1745724651871/UK3.jpg',
        uk: 'https://websiteoss.ecoflow.com/upload/image/1745724651871/UK3.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1745724528885/DE3.jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1745724560346/FR3.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1745724615515/IT3.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1745724561133/ES3.jpg',
        au: 'https://websiteoss.ecoflow.com/upload/image/1745724651871/UK3.jpg',
    };
    const item4 = {
        jp: 'https://websiteoss.ecoflow.com/upload/image/1748315576986/4.jpg',
        us: 'https://websiteoss.ecoflow.com/upload/image/1744598090189/4-us.jpg',
        ca: 'https://websiteoss.ecoflow.com/upload/image/1744598090518/4.jpg',
        eu: 'https://websiteoss.ecoflow.com/upload/image/1745724652272/UK4.jpg',
        nl: 'https://websiteoss.ecoflow.com/upload/image/1745724652272/UK4.jpg',
        uk: 'https://websiteoss.ecoflow.com/upload/image/1745724652272/UK4.jpg',
        de: 'https://websiteoss.ecoflow.com/upload/image/1745724529063/DE4.jpg',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1745724559978/FR4.jpg',
        it: 'https://websiteoss.ecoflow.com/upload/image/1745724615344/IT4.jpg',
        es: 'https://websiteoss.ecoflow.com/upload/image/1745724560935/ES4.jpg',
        au: 'https://websiteoss.ecoflow.com/upload/image/1745724652272/UK4.jpg',
    };
    const itemsA = [
        {
            pc: getImgUrl(item1),
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: getImgUrl(item2),
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: getImgUrl(item3),
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: getImgUrl(item4),
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];
    return (
        <div className={`section-bg-black ${styles.comp}`} id="SectionL">
            <EcoSpace />
            <EcoSectionCommon sectionCommonLayout="left" theme="black" title={t('title')} />
            <EcoSpaceSmall />
            <EcoGraphicSwiper theme="black" uiType="ui4" items={itemsA} />
            <EcoSpace />
        </div>
    );
}
